import '../styles/globals.css'
import Head from 'next/head'

export default function MyApp({ Component, pageProps }) {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Emerald Booking Engine - Book your stay directly with us" />
        <title>Emerald Booking Engine</title>
      </Head>
      <Component {...pageProps} />
    </>
  )
} 